@if(!(connection.connected$ | async)){
<lib-spinner-overlay>
  <mat-icon>wifi_off</mat-icon>
</lib-spinner-overlay>
}

@if(loading){
<lib-spinner-overlay></lib-spinner-overlay>
}
@if(!loading && language){
<dba-app-header (logout)="appService.logout()" [showLanguageSelect]="false">
   
  @if(appService.CurrentUser){

  <!-- <button mat-icon-button routerLink="/">
    <mat-icon [matBadge]="todosCount" matBadgePosition="above after" matBadgeColor="accent">Check</mat-icon>
  </button>  
       -->
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>menu</mat-icon>
  </button>
  }
 
  <mat-menu #menu="matMenu">
    <a mat-menu-item routerLink="">{{language.Home | translationPipe}}</a>
     <!-- <a mat-menu-item routerLink="/debtor-list">{{language.debitoren | translationPipe}}</a>  -->
    
    <button mat-menu-item (click)="refresh()">
      <mat-icon>refresh</mat-icon> Refresh
    </button>
    <div mat-menu-item>
      <mat-icon>info</mat-icon> {{environment.version}}
    </div>
  </mat-menu>

</dba-app-header>

<div class="content">
  @if(appService.CurrentUser){
  <router-outlet></router-outlet>
  }@else {
  <lib-app-login [account-actions-visible]="false" alt-user-label="Benutzer"></lib-app-login>
  }
</div>
}

<!-- @if(!loading){<lib-scanner></lib-scanner>} -->